/* The door into the cat builder.  The panel itself styles itself from
   packages/client/src/customizer/panel.js; only the always-on-screen button is page
   furniture. */
#open-customizer{
  position:fixed;top:16px;left:16px;z-index:3;
  font-family:inherit;font-size:.68rem;letter-spacing:.05em;padding:9px 14px;
  color:var(--accent);background:var(--panel);border:1px solid var(--edge);
  border-radius:4px;cursor:pointer;pointer-events:auto;
  backdrop-filter:blur(9px);-webkit-backdrop-filter:blur(9px);
  transition:color .15s,border-color .15s,background .15s;
}
#open-customizer:hover{background:var(--accent);border-color:var(--accent);color:#171812}
#open-customizer:focus-visible{outline:2px solid var(--accent);outline-offset:2px}
